export function dashboardPathForUser(user) {
  if (!user) return "/login";
  if (user.role === "STUDENT") {
    return user.profile?.profile_completed ? "/dashboard" : "/onboarding";
  }
  if (user.role === "MARKETING_EXECUTIVE") return "/me";
  if (user.role === "SUPER_ADMIN") return "/admin";
  return "/";
}
